import React, { useState, useEffect } from 'react';

const AnimatedLogo = () => {
  
  const logos = ['MVP Development', 'AI Integrations', 'Software Architecture Design',' Data Engineering Solutions','Data Analytics','Market Research ',' ML Models '];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => { 
      setAnimate(true);
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % logos.length);
        setAnimate(false);
      }, 1000); // Duration of the animation
    }, 2500); // 2 seconds delay + 0.5 seconds animation

    return () => clearInterval(interval);
  }, [logos.length]);

  return (
    <div className="relative   w-[12rem]   min-[320px]:w-[17rem] sm:w-[25rem]  inline-block h-[4rem]  min-[320px]:h-[2rem] sm:h-[2rem]   overflow-hidden ">
      {/* Current logo sliding out */}
      <div
        className={`absolute   top-0 left-0 transition-transform duration-1000 flex justify-center items-center text-center h-full w-full   md:px-4 lg:px-0 ease-in-out ${
          animate
            ? currentIndex === 0
              ? 'translate-y-full'
              : currentIndex === 1
              ? 'translate-y-full'
              : currentIndex === 2
              ? 'translate-y-full'
              : 'translate-y-full' 
            : 'translate-y-0'
        }`}
        key={currentIndex}
        style={{ transform: animate ? 'translateY(100%)' : 'translateY(0)' }}
      >

        <h3 className='text-lg sm:text-2xl text-[#FFC067] font-bold '>{logos[currentIndex]}</h3>
      </div>

      {/* Next logo sliding in */}
      <div
        className={`absolute top-0 left-0 transition-transform flex justify-center items-center text-center duration-1000 h-full w-full   md:px-4 lg:px-0 ease-in-out ${
          animate ? 'translate-y-0' : 'translate-y-[-100%]'
        }`}
        key={`next-${(currentIndex + 1) % logos.length}`}
        style={{ transform: animate ? 'translateY(0)' : 'translateY(-100%)', marginTop: 'px' }}
      >

        <h3 className='text-lg sm:text-2xl text-[#FFC067] font-bold'>{logos[(currentIndex + 1) % logos.length]}</h3>

      </div>

      {/* Previous logo (for smoother transitions when looping) */}
      <div
        className={`absolute top-0 left-0 transition-transform flex justify-center items-center text-center duration-1000 h-full w-full    md:px-4 lg:px-0 ease-in-out ${
          animate ? 'translate-y-[-200%]' : 'translate-y-[-100%]'
        }`}
        key={`prev-${(currentIndex - 1 + logos.length) % logos.length}`}
        style={{ transform: animate ? 'translateY(-200%)' : 'translateY(-100%)' }}
      >

        <h3 className='text-lg sm:text-2xl text-[#FFC067] font-bold' >{logos[(currentIndex - 1 + logos.length) % logos.length]}</h3>

      </div>
    </div>
  );
};

const ServicesNameAnimation = () => {
  return (
    <div className="border-2  border-[#FFC067] liquidGlassEffectForHeader rounded-xl pt-2 px-2 inline-block  ">
      <AnimatedLogo  />
    </div>
  );
};

export default ServicesNameAnimation;